import App from '../App'

//将所有页面import进来
//BrowserRouter-history模式，HashRouter-hash模式
import {BrowserRouter,Routes,Route}  from 'react-router-dom'
const BaseRouter=()=>{
    return (
       < BrowserRouter>
            <Routes>
                <Route path="/:abc/:cbd/:yy/:mm/:dd/:pdfname" element={<App/>}>
            </Route>
            
            </Routes>
            
        </BrowserRouter>
    )
}
export default BaseRouter
